import { Component, Mixins } from 'vue-property-decorator';
import { CompanyForDigitalSign } from '../types/auth-via-digital-sign';
import { DigitalSign } from '../types/digital-sign';
import AuthDigitalSign from './AuthDigitalSign';

@Component
export default class ChangeCompany extends Mixins(
	AuthDigitalSign
) {

	preparedCompany: CompanyForDigitalSign | null = null

	prepareNewCompany(company: CompanyForDigitalSign | null) {
		this.preparedCompany = company;
		this.passwordDialog = true;
		this.digitalSignMfoUl = company?.branch?.mfoUl || '';
		this.digitalSignCrmId.flCrmId = company?.flCrmId || 0;
		this.digitalSignCrmId.ulCrmId = company?.ulCrmId || 0;
	}

	async onSubmitNewCompany(digitalSign: DigitalSign) {
		this.selectedDigitalSign = digitalSign;

		this.setProfileDigitalSign(digitalSign);
		await this.onSubmitDigitalSignPassword();
	}

}